import { render, staticRenderFns } from "./Gvp.vue?vue&type=template&id=9a0ac812&scoped=true"
import script from "./Gvp.vue?vue&type=script&lang=js"
export * from "./Gvp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0ac812",
  null
  
)

export default component.exports